<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.OpenJobInterviewDecisionsTitle"
    :count="data.count"
  >
    <div
      v-if="empty"
      v-t="'Recruiting.Dashboard.OpenJobInterviewDecisionsNoFeedbacks'"
      class="p-3"
    />
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="item in data.jobInterviewDecisions"
        :key="item.id"
        class="list-group-item dashboard-open-job-interview-desicion-dashlet-item dashboard-dashlet-list-item action-item"
        @click="itemClicked(item)"
      >
        <div class="row">
          <div class="col-auto py-0 dashboard-dashlet-user-image">
            <img
              :src="getApplicantImage(item)"
              :alt="item.applicantName"
              class="dashboard-dashlet-image-thumbnail user-image user-image--xs"
            />
          </div>
          <div class="col py-0">
            <a-dashlet-list-item-title>
              <span slot="title" v-text="item.applicantName" />
              <div slot="addition" class="text-pf-danger">
                {{
                  $t("Recruiting.Dashboard.OpenJobInterviewDecisionsDate", [
                    $dtFormat(new Date(item.dateTime))
                  ])
                }}
              </div>
            </a-dashlet-list-item-title>
            <div class="row">
              <div class="col py-0 text-pf-muted">
                <span v-t="item.jobPostingTitle" /><br />
                <span v-t="item.type" />
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <template #actions>
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-pf-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard.vue";
import DashletListItemTitle from "~/recruiting-system/components/dashboard/DashletListItemTitle.vue";
import utils from "./utils/utils.js";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-dashlet-list-item-title": DashletListItemTitle
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    empty: function () {
      return this.data.count < 1;
    }
  },
  methods: {
    getApplicantImage(decision) {
      return `/persis/main?fn=bm.img&bwg_refnr=${decision.applicationId}`;
    },
    itemClicked(decision) {
      const route = `/main/bm.vorst/edit?vst_tn_refnr=${decision.id}&bwg_refnr=${decision.applicationId}&redir=(BE(L3JlY3J1aXRpbmcvZGFzaGJvYXJk`;
      this.$router.push(route);
    },
    goToOverview() {
      if (this.empty) {
        return;
      }
      utils.delZSearchSession("iBM_VORST_FK");
      const route = `/main/bm.vorst?Checkbox_VORGESCHL_PRIO_AKTION=1`;
      this.$router.push(route);
    }
  }
};
</script>
